import { getSwaggerFiles, postSwaggerFiles, deleteSwaggerFiles } from '@/services';
import { SWAGGER_FILE_PATH } from '@/constants';
import { message } from 'antd';

const model = {
  namespace: 'swaggerFileModel',
  state: {
    files: [],
    currentFile: {},
  },
  subscriptions: {},
  effects: {
    *getFiles(_, { call, put }) {
      try {
        yield put({
          type: 'appModel/setTableLoading',
          payload: {
            modelName: 'swaggerFileModel',
            loading: true,
          },
        });

        const data = yield call(getSwaggerFiles);
        yield put({
          type: 'setState',
          payload: {
            files: data.map((item) => ({
              fileName: item,
              path: SWAGGER_FILE_PATH,
            })),
            currentFile: {},
          },
        });
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      } finally {
        yield put({
          type: 'appModel/setTableLoading',
          payload: {
            modelName: 'swaggerFileModel',
            loading: false,
          },
        });
      }
    },
    *postFiles({ payload, callback }, { call, put }) {
      try {
        yield call(postSwaggerFiles, payload);

        yield put({ type: 'getFiles' });

        message.success('Success');
        callback && callback();
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      }
    },
    *deleteFiles(_, { call, select, put }) {
      try {
        const { currentFile } = yield select(({ swaggerFileModel }) => ({
          currentFile: swaggerFileModel.currentFile,
        }));

        yield call(deleteSwaggerFiles, currentFile);

        yield put({ type: 'getFiles' });
        message.success('Success');
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      }
    },
    *onCurrentFileChange({ payload }, { put }) {
      try {
        yield put({
          type: 'setState',
          payload: {
            currentFile: payload,
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};

export default model;
